import axios from 'axios';
import { header } from '../../components/header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const getCurrentCashSession = async (storeId) => {
  const res = await axios.get(`${API_URL}/stores/${storeId}/cash-sessions/current`, header());
  return res.data;
};

export const openCashSession = async (storeId, payload) => {
  const res = await axios.post(`${API_URL}/stores/${storeId}/cash-sessions/open`, payload, header());
  return res.data;
};

export const validateCashSession = async (sessionId, payload = {}) => {
  const res = await axios.post(`${API_URL}/cash-sessions/${sessionId}/validate`, payload, header());
  return res.data;
};

export const closeCashSession = async (sessionId, payload) => {
  const res = await axios.post(`${API_URL}/cash-sessions/${sessionId}/close`, payload, header());
  return res.data;
};

export const getCashSessionSummary = async (sessionId) => {
  const res = await axios.get(`${API_URL}/cash-sessions/${sessionId}/summary`, header());
  return res.data;
};

export const getPaymentMethods = async (storeId) => {
  const res = await axios.get(`${API_URL}/payment-methods`, {
    ...header(),
    params: storeId ? { storeId } : undefined,
  });
  return res.data;
};

export const createPaymentMethod = async (payload) => {
  const res = await axios.post(`${API_URL}/payment-methods`, payload, header());
  return res.data;
};

export const createPaymentMethodsBulk = async (payload) => {
  const res = await axios.post(`${API_URL}/payment-methods/bulk`, payload, header());
  return res.data;
};

export const updatePaymentMethod = async (id, payload) => {
  const res = await axios.patch(`${API_URL}/payment-methods/${id}`, payload, header());
  return res.data;
};

export const getAccounts = async (params = {}) => {
  const res = await axios.get(`${API_URL}/accounts`, {
    ...header(),
    params,
  });
  return res.data;
};

export const createAccount = async (payload) => {
  const res = await axios.post(`${API_URL}/accounts`, payload, header());
  return res.data;
};

export const updateAccount = async (id, payload) => {
  const res = await axios.patch(`${API_URL}/accounts/${id}`, payload, header());
  return res.data;
};

export const getAccountMovements = async (params = {}) => {
  const res = await axios.get(`${API_URL}/accounts/movements`, {
    ...header(),
    params,
  });
  return res.data;
};

export const createPosOrder = async (payload) => {
  const res = await axios.post(`${API_URL}/pos/orders`, payload, header());
  return res.data;
};

export const addPosOrderPayments = async (orderId, payload) => {
  const res = await axios.post(`${API_URL}/pos/orders/${orderId}/payments`, payload, header());
  return res.data;
};

export const createPosReturn = async (orderId, payload) => {
  const res = await axios.post(`${API_URL}/pos/orders/${orderId}/return`, payload, header());
  return res.data;
};
